export const loadingStart = () => ({
    type: 'LOADING_START'
});

export const loadingStop = () => ({
    type: 'LOADING_STOP'
});